import type { FC } from "react";
import MultiSelect from "../../components/select/MultiSelect";
import { GROUP_TYPE_OPTIONS } from "../groupTypeOptions";
import type { GroupType } from "../orderTypes";

interface Props {
  readonly values: GroupType[];
  readonly onChange: (groupTypes: GroupType[]) => void;
}

const GroupTypeMultiSelect: FC<Props> = ({ values, onChange }) => (
  <MultiSelect
    label="Rodzaj grupy"
    fullWidth
    selected={values}
    values={GROUP_TYPE_OPTIONS}
    onSelect={(selected) => onChange(selected as GroupType[])}
  />
);

export default GroupTypeMultiSelect;
